import { render, staticRenderFns } from "./PanelPreviewPhones.vue?vue&type=template&id=a8e06f96&scoped=true"
import script from "./PanelPreviewPhones.vue?vue&type=script&lang=js"
export * from "./PanelPreviewPhones.vue?vue&type=script&lang=js"
import style0 from "./PanelPreviewPhones.vue?vue&type=style&index=0&id=a8e06f96&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e06f96",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBtn,QTooltip});
